// Consents;
// SelfAuth;
// ParentConsents;
// ParentEmail;
// ParentEmailComplete;
// CheckAccount;
// ExistingAccounts;
// Email;
// IdPasswd;
// AccountCreation;
// Success;
// SampleGrid;

const FLOW = {
  DEFAULT: {
    NORMAL: [
      { curr: 'ConsentsDefault', next: 'SelfAuth', nextIncreaseCount: true },
      { curr: 'SelfAuth', next: 'CheckAccount', nextIncreaseCount: true },
      { curr: 'CheckAccount', next: 'ExistingAccounts', nextIncreaseCount: false },
      { curr: 'ExistingAccounts', next: 'Email', nextIncreaseCount: true },
      { curr: 'Email', next: 'IdPasswd', nextIncreaseCount: true },
      { curr: 'IdPasswd', next: 'AccountCreation', nextIncreaseCount: false },
      { curr: 'AccountCreation', next: 'Success', nextIncreaseCount: true },
      { curr: 'Success', next: '', nextIncreaseCount: false }
    ],
    MINOR: [
      { curr: 'ConsentsDefault', next: 'SelfAuth', nextIncreaseCount: true },
      { curr: 'SelfAuth', next: 'RestrictedGames', nextIncreaseCount: false },
      { curr: 'RestrictedGames', next: 'ParentConsents', nextIncreaseCount: true },
      { curr: 'ParentConsents', next: 'ParentEmail', nextIncreaseCount: true },
      { curr: 'ParentEmail', next: 'ParentEmailComplete', nextIncreaseCount: false },
      { curr: 'ParentEmailComplete', next: 'CheckAccount', nextIncreaseCount: true },
      { curr: 'CheckAccount', next: 'ExistingAccounts', nextIncreaseCount: false },
      { curr: 'ExistingAccounts', next: 'Email', nextIncreaseCount: true },
      { curr: 'Email', next: 'IdPasswd', nextIncreaseCount: true },
      { curr: 'IdPasswd', next: 'AccountCreation', nextIncreaseCount: false },
      { curr: 'AccountCreation', next: 'Success', nextIncreaseCount: true },
      { curr: 'Success', next: '', nextIncreaseCount: false }
    ]
  },
  PROMOTION: {
    NORMAL: [
      { curr: 'Promotion', next: 'ConsentsPromotion', nextIncreaseCount: true },
      { curr: 'ConsentsPromotion', next: 'SelfAuth', nextIncreaseCount: true },
      { curr: 'SelfAuth', next: 'PromotionCheckAccount', nextIncreaseCount: true },
      { curr: 'PromotionCheckAccount', next: 'Email', nextIncreaseCount: false },
      { curr: 'Email', next: 'IdPasswd', nextIncreaseCount: true },
      { curr: 'IdPasswd', next: 'AccountCreation', nextIncreaseCount: false },
      { curr: 'AccountCreation', next: 'Success', nextIncreaseCount: true },
      { curr: 'Success', next: '', nextIncreaseCount: false }
    ],
    MINOR: [
      { curr: 'Promotion', next: 'ConsentsPromotion', nextIncreaseCount: true },
      { curr: 'ConsentsPromotion', next: 'SelfAuth', nextIncreaseCount: true },
      { curr: 'SelfAuth', next: 'RestrictedGames', nextIncreaseCount: false },
      { curr: 'RestrictedGames', next: 'ParentConsents', nextIncreaseCount: true },
      { curr: 'ParentConsents', next: 'ParentEmail', nextIncreaseCount: true },
      { curr: 'ParentEmail', next: 'ParentEmailComplete', nextIncreaseCount: false },
      { curr: 'ParentEmailComplete', next: 'PromotionCheckAccount', nextIncreaseCount: true },
      { curr: 'PromotionCheckAccount', next: 'Email', nextIncreaseCount: false },
      { curr: 'Email', next: 'IdPasswd', nextIncreaseCount: true },
      { curr: 'IdPasswd', next: 'AccountCreation', nextIncreaseCount: false },
      { curr: 'AccountCreation', next: 'Success', nextIncreaseCount: true },
      { curr: 'Success', next: '', nextIncreaseCount: false }
    ]
  }
};

export default FLOW;
